import React, { useState, useEffect, useRef  } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import backlogo from '../../Assets/App_icon/back.png';

const WelcomeImage = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');
 
  const fileInputRef = useRef(null);
  const fileInputRefE = useRef(null);
  const navigate = useNavigate();
  

  const [imageData, setImageData] = useState([]);
  
  const [imagePreview, setImagePreview] = useState(null);
  const [eImagePreview, setEImagePreview] = useState(null);

  const today = new Date().toISOString().split("T")[0];

  const handleBack = () => {
    navigate('../dashboard');
  };

    // Escape key press handling
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
            handleBack();
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, []);

    useEffect(() => { 
      const fetchWelomeData = async () => { 
          const formData = new FormData();
          formData.append("type", "list");
          formData.append("store", store);
          formData.append("wi_data", '');

          try {
            const response = await fetch(`${host_url}/welcome_mlist`, {
              method: 'POST',
              body: formData,
            });
            const data = await response.json();
            setImageData(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
      }; 
     fetchWelomeData(); 
    }, [host_url]);


    const handleFileChange = async (e) => {
      const file = e.target.files[0];
      
      if(file) {
        
        const previewUrl = URL.createObjectURL(file);
        setImagePreview(previewUrl);

          console.log(file);
          const formData = new FormData();
          formData.append('image', file);
          formData.append("type", "Gujarati_update");
          formData.append("store", store);
          formData.append("welcome_id", imageData.welcome_id );
          formData.append("end_date", imageData.end_date );
          try {
            const response = await fetch(`${host_url}/welcome_mlist`, {
              method: 'POST',
              body: formData,
            });
            
            const data = await response.json();
            setImageData(data);
          } catch (error) {
            console.error('Error fetching categories:', error);
          }   
      }
    };

    const handleFileChangeE = async (e) => {
      const fileE = e.target.files[0];
      
      if(fileE) {
        const previewUrl = URL.createObjectURL(fileE);
        setEImagePreview(previewUrl);
        
          console.log(fileE);
          const formData = new FormData();
          formData.append('image', fileE);
          formData.append("type", "English_update");
          formData.append("store", store);
          formData.append("welcome_id", imageData.welcome_id );
          formData.append("end_date", imageData.end_date );
          try {
            const response = await fetch(`${host_url}/welcome_mlist`, {
              method: 'POST',
              body: formData,
            });
            
            const data = await response.json();
            setImageData(data);
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
      }
    };

    const handleDateChange = async () => {
      
      if(imageData.end_date) {
        const formData = new FormData();
        formData.append("type", "Date_update");
        formData.append("store", store);
        formData.append("welcome_id", imageData.welcome_id );
        formData.append("end_date", imageData.end_date );
        try {
          const response = await fetch(`${host_url}/welcome_mlist`, {
            method: 'POST',
            body: formData,
          });
          
          const data = await response.json();
          setImageData(data);
        } catch (error) {
          console.error('Error fetching categories:', error);
        }

      }
    };
    
  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Welcome Image</b>
              <div ></div>
          </div>
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >
                <th>Gujarati</th>
                <th>EngLish</th>
                <th>Expire_Date</th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
                <tr style={{ lineHeight: '10px', cursor: 'default' }} >
                  <td style={{ padding: 10 }}>
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img 
                            src={imagePreview ? imagePreview : imageData.image_url} 
                            alt="Category" 
                            style={{ width: '200px', height: '200px', objectFit: 'contain', cursor: 'pointer' }} 
                            onClick={() => fileInputRef.current.click()} 
                        />
                        <input 
                          type="file" 
                          style={{ display: 'none' }} 
                          accept="image/*" 
                          ref={fileInputRef} 
                          onChange={handleFileChange} 
                        />
                      </div>
                  </td>
                  <td style={{ padding: 10 }}>
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img 
                            src={eImagePreview ? eImagePreview : imageData.image_Eurl} 
                            alt="Category" 
                            style={{ width: '200px', height: '200px', objectFit: 'contain', cursor: 'pointer' }} 
                            onClick={() => fileInputRefE.current.click()} 
                        />
                        <input 
                          type="file" 
                          style={{ display: 'none' }} 
                          accept="image/*" 
                          ref={fileInputRefE} 
                          onChange={handleFileChangeE} 
                        />
                      </div>
                  </td>
                 
                  <td>
                    <h5 style={{ color: imageData.end_date > today ? 'green' : 'red', marginBottom: 20 }}>{imageData.end_date > today ? 'Image is Live' : 'Image is Expired'}</h5>
                    <input type="date"  
                            style={{
                                    height: 50,  
                                    lineHeight: '50px', // Ensures proper vertical alignment
                                    padding: '0 10px',  // Adjust padding to fit text
                                    fontSize: '16px',   // Adjust font size for better visibility
                                    display: 'flex',   
                                    justifyContent: 'center' // Centers horizontally
                                  }}  
                            value={imageData.end_date ? new Date(imageData.end_date).toISOString().split("T")[0] : ""}
                            onChange={(e) => setImageData({ ...imageData, end_date: e.target.value })}
                    />
                    
                    <Button color="success" style={{ flex: 1, marginLeft: '10px', marginRight: '10px' }} onClick={handleDateChange}>
                      Date Update
                    </Button>
                  </td>
                </tr>
            </tbody>
            <tfoot>
              <tr >
                <th ></th>
                <th ></th>
                <th className="cell-right"><span style={{ paddingRight: '15px' }}></span></th>
              </tr>
            </tfoot>
          </table>
    </div>    
  );
};

export default WelcomeImage;
